import {
  Box, Button, Card, CardHeader, Typography,
} from '@mui/material';
import useStyles from '../../hooks/useStyles';
import styles from './style';
import { SelectBox } from '../FormComponents';

export default function DashboardCards(props) {
  const {
    children = null,
    title = '',
    count = null,
    subHeading = '',
    onClick = () => {},
    buttonText = '',
    showButton = false,
    showHeader = true,
    graphType = false,
    handleSelection = () => {},
    onClickTitle = null,
    error,
    viewOption,
    setViewOption,
    view,
    action = null,
    packageList,
    selectedPackage,
    handlePackageChange,
  } = props;

  const classes = useStyles(styles)();

  return (
    <Card className={showHeader ? classes.cardStyle : classes.noHeaderStyle}>
      {showHeader && (
        <Box className={classes.boxStyle}>
          <Box>
            <Box
              sx={{
                display: 'flex',
                alignItems: 'center',
                width: '100%',
                gap: 1,
              }}
            >
              <CardHeader
                title={title}
                style={{ padding: 0 }}
                {...(onClickTitle && { onClick: onClickTitle })}
                sx={{ cursor: onClickTitle && 'pointer' }}
              />
              {count && <Typography className={classes.subHeaderStyle}>{count}</Typography>}
            </Box>
            {subHeading && <Typography className={classes.subHeaderStyle}>{subHeading}</Typography>}
          </Box>
          <Box display="flex" alignItems="center" gap={1}>
            {(graphType || view) && !error && (
              <SelectBox
                title="View"
                height="35px"
                value={viewOption}
                data={[{ id: 'month', name: 'Monthly', value: 'month' }, { id: 'week', name: 'Weekly', value: 'week' }]}
                onChange={(e) => setViewOption(e.target.value)}
              />
            )}
            {graphType && !error && (
              <SelectBox
                title="Type"
                height="35px"
                value={graphType}
                data={[{ id: 'users', name: 'Users', value: 'users' }, { id: 'operations', name: 'Operations', value: 'operations' }]}
                onChange={(e) => handleSelection(e)}
              />
            )}
            {packageList?.length > 0 && !error && (
              <SelectBox
                title="Package"
                height="35px"
                value={selectedPackage}
                data={packageList}
                onChange={handlePackageChange}
              />
            )}
            {action && action}
            {showButton && (
              <Button variant="outlined" onClick={onClick}>
                {buttonText}
              </Button>
            )}
          </Box>
        </Box>
      )}
      {children}
    </Card>
  );
}
